import React from 'react';
import { SettingsLayout } from '@/components/layouts';
import { SettingsCard } from '@/components/organisms/SettingsCard';
import { APIInformation } from '@/components/molecules/Settings/APIInformation';
import { PrivateLayout } from '@/components/Middleware';
import { ApiKeyList } from '@/components/molecules/ApiKeysList';

const APIs = () => {
  return (
    <>
      <PrivateLayout>
        <SettingsLayout hideSettingsTabPanel={true} hideHeaderRightSide={false} containerSize={'md'}>
          <SettingsCard title={'API Information'}>
            <APIInformation />
            <ApiKeyList />
          </SettingsCard>
        </SettingsLayout>
      </PrivateLayout>
    </>
  );
};

export { APIs };
